import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import cN from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@Redux/search/store';
import { setFilterData } from '@Redux/search/actions';
import { I_Filter } from '@Redux/search/interfaces';

import * as Tag from '@features/ui/Tag';

const FilterConditions = () => {
    const moduleName = 'conditions';

    const { FilterData } = useSelector((state: RootState) => state.search);
    const dispatch = useDispatch();

    const [showResetTag, setShowResetTag] = useState(false);

    const tagTxt: { [key: string]: string } = {
        transfer: '',
        airport: '', // 航空公司
        departureTime: '', // 出發時間
        arrivalTime: '', //抵達時間
        departure: '出發', //出發地機場
        arrival: '抵達', // 目的地機場
        transferPoint: '轉機點', //轉機點
        Cabin: '艙等', //艙等
        crossday: '', //是否為跨日
        Gifts: '',
    };

    const calcTagTxt = (filterType: string, text: string) => tagTxt[filterType] + text;

    const clickTag = (filterType: string, value: string | number, payload: any = null) => {
        if (!FilterData[filterType]) return;

        const newFilterData = JSON.parse(JSON.stringify(FilterData));

        if (filterType === 'seqAirport' && !!payload) {
            const { subType, seqNum } = payload;

            const targetSeq = newFilterData.seqAirport.find((seq: any) => seq.seqNum === seqNum);

            targetSeq[subType] = targetSeq[subType].filter(
                (child: I_Filter) => child.value !== value
            );
        } else {
            newFilterData[filterType] = newFilterData[filterType].filter(
                (child: I_Filter) => child.value !== value
            );
        }

        dispatch(setFilterData(newFilterData));
    };

    useEffect(() => {
        if (!FilterData || Object.keys(FilterData).length === 0) return setShowResetTag(false);

        let showTag = false;
        if (
            FilterData.seqAirport?.some(
                (seq: any) => seq.departure?.length > 0 || seq.arrival?.length > 0
            )
        ) {
            showTag = true;
        }

        if (
            Object.keys(FilterData)
                .filter((key) => key !== 'dpTimes' && key !== 'seqAirport')
                .some((element) => FilterData[element].length > 0)
        ) {
            showTag = true;
        }

        setShowResetTag(showTag);
    }, [FilterData]);

    return (
        <div className={cN(moduleName, styles[`${moduleName}`])}>
            {FilterData &&
                Object.keys(FilterData).length > 0 &&
                Object.keys(FilterData).map((child) => {
                    if (child === 'dpTimes') return null;

                    if (child === 'seqAirport')
                        return FilterData.seqAirport.map(
                            (seq: { seqNum: string; departure: []; arrival: [] }) => {
                                return (
                                    <React.Fragment key={`seqAirport-${seq.seqNum}`}>
                                        {seq.departure?.length > 0 &&
                                            seq.departure.map(
                                                (c: { text: string; value: string }) => (
                                                    <div
                                                        key={`seq${seq.seqNum}Departure-${c.text}-${c.value}`}
                                                        className={styles.Tagwrap}
                                                        onClick={() =>
                                                            clickTag(child, c.value, {
                                                                seqNum: seq.seqNum,
                                                                subType: 'departure',
                                                            })
                                                        }
                                                    >
                                                        <Tag.Selectable
                                                            text={calcTagTxt('departure', c.text)}
                                                            isClosable
                                                        />
                                                    </div>
                                                )
                                            )}

                                        {seq.arrival?.length > 0 &&
                                            seq.arrival?.map(
                                                (c: { text: string; value: string }) => (
                                                    <div
                                                        key={`seq${seq.seqNum}Arrival-${c.text}-${c.value}`}
                                                        className={styles.Tagwrap}
                                                        onClick={() =>
                                                            clickTag(child, c.value, {
                                                                seqNum: seq.seqNum,
                                                                subType: 'arrival',
                                                            })
                                                        }
                                                    >
                                                        <Tag.Selectable
                                                            text={calcTagTxt('arrival', c.text)}
                                                            isClosable
                                                        />
                                                    </div>
                                                )
                                            )}
                                    </React.Fragment>
                                );
                            }
                        );

                    return FilterData[child].map((c: { text: string; value: string | number }) => (
                        <div
                            key={`${child}-${c.text}-${c.value}`}
                            className={styles.Tagwrap}
                            onClick={() => clickTag(child, c.value)}
                        >
                            <Tag.Selectable text={calcTagTxt(child, c.text)} isClosable />
                        </div>
                    ));
                })}

            {showResetTag && (
                <div className={styles.Reset} onClick={() => dispatch(setFilterData(undefined))}>
                    <Tag.Selectable text="重設條件" />
                </div>
            )}
        </div>
    );
};

export default FilterConditions;
